import type { GroupType } from '@/types/group';

// ─── React Query Key Definitions ──────────────────────────
// Centralised query keys so every consumer uses the same key structure.
// This enables targeted invalidation, optimistic updates, and deduplication.

export const queryKeys = {
  dogs: {
    profiles: ['dogs', 'profiles'] as const,
    profile: (id: string) => [...queryKeys.dogs.profiles, id] as const,
    traits: (id: string) => [...queryKeys.dogs.profile(id), 'traits'] as const,
    owners: (id: string) => [...queryKeys.dogs.profile(id), 'owners'] as const,
  },
  account: {
    me: ['account', 'me'] as const,
    collectibles: ['account', 'collectibles'] as const,
  },
  trails: {
    myTrails: ['trails', 'my'] as const,
    savedTrails: ['trails', 'saved'] as const,
    detail: (id: string, dogId?: string) => ['trails', 'detail', id, dogId ?? null] as const,
    reviews: (id: string) => ['trails', 'reviews', id] as const,
    forYou: (lat?: number, lng?: number) => ['trails', 'forYou', lat, lng] as const,
    nearby: (lat?: number, lng?: number, dist?: number) => ['trails', 'nearby', lat, lng, dist] as const,
    byTag: (tag: string, lat?: number, lng?: number) => ['trails', 'tag', tag, lat, lng] as const,
    search: (params: Record<string, any>) => ['trails', 'search', params] as const,
  },
  notifications: { all: ['notifications'] as const },
  groups: {
    all: ['groups'] as const,
    mine: (type?: GroupType) => ['groups', 'mine', type ?? null] as const,
    detail: (id: string) => ['groups', 'detail', id] as const,
    invites: (id: string) => ['groups', 'invites', id] as const,
    trails: (id: string) => ['groups', 'trails', id] as const,
  },
  invites: { mine: ['invites', 'mine'] as const },
  misc: { dogSvg: ['misc', 'dogSvg'] as const },
} as const;